import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  defaultCommunities: []
}

const getters = {
  defaultCommunities: state => state.defaultCommunities
}

const mutations = {
  setDefaultCommunities: (state, defaultCommunities) => {
    state.defaultCommunities = defaultCommunities
  }
}

const updateDefaultCommunities = async ({ commit }, defaultCommunities) => {
  await axios.put(`${config.getRootApi()}/config/default-communities`, {
    idCommunities: defaultCommunities.map(c => c.id)
  })
  commit('setDefaultCommunities', defaultCommunities)
}

const actions = {
  async fetchDefaultCommunities({ commit }) {
    const response = await axios.get(`${config.getRootApi()}/config/default-communities`)
    commit('setDefaultCommunities', response.data)
    return response.data
  },
  async removeDefaultCommunities({ commit, state }, community) {
    await updateDefaultCommunities({ commit }, state.defaultCommunities.filter(
      c => c.id !== community.id
    ))
  },
  async addDefaultCommunities({ commit, state }, community) {
    if (!state.defaultCommunities.some(c => c.id === community.id)) {
      await updateDefaultCommunities({ commit }, [...state.defaultCommunities, community])
    }
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
